import React, { useEffect, useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const officeAddress = "3rd Floor, D Tower, Sai Enclave, Patna, Bihar, India";

// Used until the exact address is located by Google Maps
const fallbackCenter = {
  lat: 25.5941,
  lng: 85.1376,
};

const googleMapsApiKey =
  process.env.REACT_APP_GOOGLE_MAPS_KEY ||
  "AIzaSyBRhWOAVlzFOCmuVR58SLzfY_dZs7NpQDk";

const mapContainerStyle = {
  height: "100%",
  width: "100%",
  borderRadius: "12px",
};

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mapCenter, setMapCenter] = useState(fallbackCenter);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
  });

  useEffect(() => {
    if (!isLoaded || !window.google) {
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode(
      {
        address: officeAddress,
      },
      (results, status) => {
        if (status === "OK" && results?.[0]) {
          const location = results[0].geometry.location;

          setMapCenter({
            lat: location.lat(),
            lng: location.lng(),
          });
        }
      },
    );
  }, [isLoaded]);

  return (
    <footer
      style={{
        backgroundColor: "#0F172A",
        color: "#ffffff",
        padding: isMobile ? "2.5rem 1rem" : "4rem 3rem",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <img
                src="/images/innobyte_logo_1.jpeg"
                alt="InnoByte Logo"
                style={{
                  width: isMobile ? "68px" : "80px",
                  marginRight: "10px",
                }}
              />

              <h4
                style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: isMobile ? "28px" : "32px",
                }}
              >
                InnoByte
              </h4>
            </div>

            <p
              style={{
                fontSize: "14px",
                color: "#94A3B8",
                lineHeight: "28px",
              }}
            >
              InnoByte is a technology system integrator delivering end-to-end
              solutions for data centres, enterprise networks, Wi-Fi,
              electronics hardware, and secure infrastructure.
            </p>
          </div>

          <div className="col-md-4 mb-4">
            <h5 style={{ marginBottom: "15px" }}>Contact</h5>

            <div className="d-flex align-items-start mb-3">
              <FaMapMarkerAlt
                style={{
                  marginRight: "10px",
                  marginTop: "4px",
                }}
              />

              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  color: "#CBD5E1",
                  lineHeight: "24px",
                }}
              >
                Corporate Office: 3rd Floor, D Tower, Sai Enclave, Patna, Bihar,
                India.
              </p>
            </div>

            <div className="d-flex align-items-center mb-2">
              <FaPhoneAlt style={{ marginRight: "10px" }} />

              <a
                href="tel:+919199997773"
                style={{
                  color: "#CBD5E1",
                  textDecoration: "none",
                }}
              >
                +91 9199997773
              </a>
            </div>

            <div className="d-flex align-items-center">
              <FaEnvelope style={{ marginRight: "10px" }} />

              <a
                href="mailto:sales@innobyteindustries.com"
                style={{
                  color: "#CBD5E1",
                  textDecoration: "none",
                }}
              >
                sales@innobyteindustries.com
              </a>
            </div>
          </div>

          <div className="col-md-4">
            <h5 style={{ marginBottom: "15px" }}>Location</h5>

            <div
              style={{
                height: isMobile ? "220px" : "150px",
                marginBottom: "20px",
              }}
            >
              {isLoaded && (
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={mapCenter}
                  zoom={14}
                  options={{
                    disableDefaultUI: true,
                  }}
                >
                  <Marker position={mapCenter} />
                </GoogleMap>
              )}
            </div>

            <div className="d-flex gap-3">
              <a
                href="https://www.linkedin.com/company/innobyte"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                style={{ color: "#0A66C2" }}
              >
                <FaLinkedin size={22} />
              </a>

              <a
                href="https://www.instagram.com/innobyte.tech"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{ color: "#E1306C" }}
              >
                <FaInstagram size={22} />
              </a>
            </div>
          </div>
        </div>

        <hr
          style={{
            borderColor: "#1E293B",
            marginTop: "30px",
          }}
        />

        <p
          style={{
            textAlign: "center",
            fontSize: "13px",
            color: "#94A3B8",
            marginBottom: 0,
          }}
        >
          © {new Date().getFullYear()} InnoByte. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
